// Import all token images directly
import ftmLogo from './tokens/ftm.svg';
import wftmLogo from './tokens/wftm.svg';
import lif3Logo from './tokens/lif3.svg';
import lshareLogo from './tokens/lshare.svg';
import gigachadLogo from './tokens/gigachad.png';
import l3usdLogo from './tokens/l3usd.png';
import usdcLogo from './tokens/usdc.svg';
import tombLogo from './tokens/tomb.png';
import tshareLogo from './tokens/tshare.png';
import usdcCoinLogo from './tokens/usdc-coin.png';

export const TokenLogos = {
  FTM: ftmLogo,
  WFTM: wftmLogo,
  LIF3: lif3Logo,
  LIF3_OLD: lif3Logo,
  LIF3_NEW: lif3Logo,
  LSHARE: lshareLogo,
  LSHARE_OLD: lshareLogo,
  LSHARE_NEW: lshareLogo,
  L3USD: l3usdLogo,
  AXLUSDC: usdcCoinLogo,
  TOMB: tombLogo,
  TSHARE: tshareLogo,
  GIGACHAD: gigachadLogo
};